import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from 'src/app/Guards/auth.guard';
import { UserLoginService } from 'src/app/login/userlogin.service';
import { PropertyListingReadAllPaginatedRequestDTO, PropertyListingReadAllPaginatedResponseDTO } from '../../Interface & Service/property-listing/property-listing.interface';
import { PropertyListingService } from '../../Interface & Service/property-listing/property-listing.service';
import { UserPropertyShortlistCreateRequestDTO, UserPropertyShortlistDeleteRequestDTO, UserPropertyShortlistDTO, UserPropertyShortlistReadByUserIdRequestDTO } from '../../Interface & Service/userPropertyShortlist/userpropertyshortlist.interface';
import { UserPropertyShortlistService } from '../../Interface & Service/userPropertyShortlist/userpropertyshortlist.service';
import { UReportListingComponent } from './u-report-listing/u-report-listing.component';


@Component({
  selector: 'app-u-listing',
  templateUrl: './u-listing.component.html',
  styleUrls: ['./u-listing.component.css']
})

export class UListingComponent implements OnInit {
  private User = inject(UserLoginService).User();
  private authGuardService = inject(AuthGuard);
  propertyListingService = inject(PropertyListingService);
  userPropertyShortlistService = inject(UserPropertyShortlistService);
  private modalService = inject(NgbModal);

  isLoggedIn!: boolean;



  PropertyListingData: PropertyListingReadAllPaginatedResponseDTO[] = [];
  filteredProperties: PropertyListingReadAllPaginatedResponseDTO[] = [];
  shortlistList: UserPropertyShortlistDTO[] = [];


  activeTab: string = 'all';
  isListingLoading: boolean = false;
  hasMore: boolean = true;


  propertyPhotos: string[] = [
    "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
    "https://images.unsplash.com/photo-1580587771525-78b9dba3b914",
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
    "https://images.unsplash.com/photo-1554995207-c18c203602cb",
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7",
    "https://images.unsplash.com/photo-1600573471864-56fdb34f10ca",
    "https://images.unsplash.com/photo-1600585154154-0968e8f8f9d3",
    "https://images.unsplash.com/photo-1560185127-6ec4fa3b17cf"
  ];

  ReadAllDTO: PropertyListingReadAllPaginatedRequestDTO = {
    userId: null,
    pageSize: 6,
    pageNo: 1,
    orderByClause: '',
    whereClause: ''
  }



  ngOnInit(): void {
    this.isLoggedIn = this.authGuardService.isLoggedIn();
    this.fetchAllListings();

    if (this.isLoggedIn) {
      this.getShortlistList();
    }

    this.updateTrack();
    this.updateAreaTrack();

  }

  fetchAllListings() {
    this.isListingLoading = true;

    this.ReadAllDTO.userId = this.isLoggedIn ? this.User.userId : null;

    this.propertyListingService.PropertyListing_ReadAllPaginated(this.ReadAllDTO).subscribe((res) => {

      const items = res.items || [];

      if (items.length === 0) {
        this.hasMore = false;
        this.isListingLoading = false;
        return;
      }

      this.PropertyListingData = this.PropertyListingData.length === 0 ? items : [...this.PropertyListingData, ...items];

      if (items.length < this.ReadAllDTO.pageSize) this.hasMore = false;

      this.isListingLoading = false;
      this.filterProperties();
    });
  }

  getShortlistList() {
    let data: UserPropertyShortlistReadByUserIdRequestDTO = {
      userId: this.User.userId,
      masterType: 'Project'
    }

    this.userPropertyShortlistService.UserPropertyShortlist_ReadByUserId(data).subscribe((res) => {
      this.shortlistList = res.items;
    })
  }


  /* ---------------------------- USER PROPERTY SHORTLIST -------------------------------------------- */

  toggleShortlist(propertyId: number) {

    const shortlistedItem = this.shortlistList.find(item => item.masterId === propertyId);

    if (shortlistedItem) {
      this.removeFromShortlist(propertyId, shortlistedItem.shortlistId);
    } else {
      this.addToShortlist(propertyId)
    }
  }

  addToShortlist(propertyId: number) {
    let data: UserPropertyShortlistCreateRequestDTO = {
      userId: this.User.userId,
      masterId: propertyId,
      masterType: 'Property',
      shortlistedOn: new Date(),
      remarks: '',
      actionUser: this.User.userId.toString()
    }

    this.userPropertyShortlistService.UserPropertyShortlist_Create(data).subscribe((res) => {
      this.shortlistList = [...this.shortlistList, res];
    })
  }

  removeFromShortlist(propertyId: number, shortlistId: number) {
    let data: UserPropertyShortlistDeleteRequestDTO = {
      shortlistId: shortlistId,
      actionUser: this.User.userId.toString()
    }

    this.userPropertyShortlistService.UserPropertyShortlist_Delete(data).subscribe((res) => {
      this.shortlistList = this.shortlistList.filter(item => item.shortlistId !== shortlistId);
    })
  }

  checkForShortlist(id: number): boolean {
    return this.shortlistList.some(f => f.masterId === id);
  }

  /* ---------------------------- USER PROPERTY SHORTLIST END -------------------------------------------- */

  calculateEMI(propertyPrice: number, interestRate = 9, tenureYears = 20): number {
    const loanPercent = this.getLoanPercentage(propertyPrice);
    const loanAmount = propertyPrice * loanPercent;
    const monthlyRate = interestRate / (12 * 100);
    const tenureMonths = tenureYears * 12;

    const emi = (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, tenureMonths)) /
      (Math.pow(1 + monthlyRate, tenureMonths) - 1);

    return Math.round(emi);
  }

  getLoanPercentage(price: number): number {
    if (price <= 3000000) return 0.9;
    else if (price <= 7500000) return 0.8;
    else return 0.7; // lower loan ratio for expensive homes
  }



  openReportListingModal(propertyId: number) {
    history.pushState(null, '', location.href);

    const modalRef: NgbModalRef = this.modalService.open(UReportListingComponent, {
      size: 'lg'
    });

    modalRef.componentInstance.masterId = propertyId;
    modalRef.componentInstance.masterType = 'Property';

    // Listen for back button and close modal
    const popStateHandler = () => {
      modalRef.close();
    };

    window.addEventListener('popstate', popStateHandler);

    modalRef.result.then((result) => {
      if (result) {

      }
    }).catch((err) => {
      console.log('Modal dismissed', err);
    })

  }




  /* ---------------------------- Infinite Scrolling START -------------------------------------------- */

  @ViewChild('scrollAnchor', { static: false }) scrollAnchor!: ElementRef;
  observer!: IntersectionObserver;

  ngAfterViewInit() {
    this.setupScrollObserver();
  }

  ngOnDestroy() {
    if (this.observer) this.observer.disconnect();
  }

  setupScrollObserver() {

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.0
    };

    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];

      if (entry.isIntersecting && !this.isListingLoading && this.hasMore) {
        this.ReadAllDTO.pageNo += 1;

        this.fetchAllListings();
      }
    }, options);

    if (this.scrollAnchor?.nativeElement) {
      this.observer.observe(this.scrollAnchor.nativeElement);
    }

  }

  resetListing() {
    this.ReadAllDTO.pageNo = 1;
    this.PropertyListingData = [];
    this.hasMore = true;
    this.fetchAllListings();
  }




  /* ---------------------------- Infinite Scrolling END -------------------------------------------- */






  /* FILTERS */

  filterProperties() {
    // Filter properties based on active tab
    this.filteredProperties = this.PropertyListingData.filter(property => {
      if (this.activeTab === 'sale') {
        return property.listingType === 'Sale';
      } else if (this.activeTab === 'rent') {
        return property.listingType === 'Rent';
      } else {
        return property;
      }
    });
  }


  // Filter variables
  minValue = 0;
  maxValue = 100; // In crores
  step = 1;
  minPrice = 0; // In lacs
  maxPrice = 100; // In crores
  leftPercent = 0;
  fillWidth = 0;

  minArea: number = 0;
  maxArea: number = 10000;
  minAreaValue: number = 0;
  maxAreaValue: number = 10000;
  areaStep: number = 50;
  areaLeftPercent: number = 0;
  areaFillWidth: number = 0;

  bhkTypes: string[] = ['1BHK', '2BHK', '3BHK', '4BHK', '5BHK'];
  selectedBHK: string = '';
  possessionStatuses: string[] = ['Ready to Move', 'Under Construction', 'Upcoming'];
  selectedPossession: string | null = null;
  postedSinceOptions: string[] = ['All', 'Yesterday', 'Last Week', 'Last 3 Week', 'Last Month', 'Last 2 Month'];
  selectedPostedSince: string | null = 'All';
  propertyAgeOptions: string[] = ['0 - 1', '1 - 3', '3 - 5', '5 - 8', '8 - 11', '11 - 14', '14 - 17', '17 +'];
  selectedPropertyAge: string | null = null;
  bathroomOptions: string[] = ['1', '2', '3', '4', '5+'];
  selectedBathroom: string | null = null;
  floorOptions: string[] = ['Ground', '1 - 3', '4 - 6', '7 - 10', '10+'];
  selectedFloor: string | null = null;
  furnishingOptions: string[] = ['Unfurnished', 'Semi-Furnished', 'Fully Furnished'];
  selectedFurnishing: string | null = null;



  // Update track for price range slider
  updateTrack(): void {
    if (this.minPrice > this.maxPrice - 1) this.minPrice = this.maxPrice - 1;
    if (this.maxPrice < this.minPrice + 1) this.maxPrice = this.minPrice + 1;

    const totalRange = this.maxValue - this.minValue;
    this.leftPercent = ((this.minPrice - this.minValue) / totalRange) * 100;
    this.fillWidth = ((this.maxPrice - this.minPrice) / totalRange) * 100;
    // this.applyFilters(); // Call applyFilters on slider change
  }

  // Update track for area range slider
  updateAreaTrack() {
    const range = this.maxAreaValue - this.minAreaValue;
    this.areaLeftPercent = ((this.minArea - this.minAreaValue) / range) * 100;
    this.areaFillWidth = ((this.maxArea - this.minArea) / range) * 100;
    // this.applyFilters(); // Call applyFilters on slider change
  }

  selectBHK(bhk: string): void {
    this.selectedBHK = this.selectedBHK === bhk ? '' : bhk;
    // this.applyFilters();
  }

  // Method to Handle Selection
  selectPossession(status: string) {
    this.selectedPossession = this.selectedPossession === status ? null : status;
    // this.applyFilters();
  }

  // Method to Handle Selection
  selectPostedSince(period: string) {
    this.selectedPostedSince = this.selectedPostedSince === period ? null : period;
    // this.applyFilters();
  }


  // Method to Handle Selection
  selectPropertyAge(age: string) {
    this.selectedPropertyAge = this.selectedPropertyAge === age ? null : age;
    // this.applyFilters();
  }

  selectBathroom(bath: string) {
    this.selectedBathroom = this.selectedBathroom === bath ? null : bath;
    // this.applyFilters();
  }


  selectFloor(floor: string) {
    this.selectedFloor = this.selectedFloor === floor ? null : floor;
    // this.applyFilters();
  }

  selectFurnishing(furnishing: string) {
    this.selectedFurnishing = this.selectedFurnishing === furnishing ? null : furnishing;
    // this.applyFilters();
  }

  // Reset all filters to default
  resetFilters() {
    this.minPrice = 0;
    this.maxPrice = 100;
    this.minArea = this.minAreaValue;
    this.maxArea = this.maxAreaValue;
    this.selectedBHK = '';
    this.selectedPossession = null;
    this.selectedPostedSince = 'All';
    this.selectedPropertyAge = null;
    this.selectedBathroom = null;
    this.selectedFloor = null;
    this.selectedFurnishing = null;

    this.updateTrack();
    this.updateAreaTrack();
    this.applyFilters();
  }

  // Construct whereClause and call API
  applyFilters() {
    const conditions: string[] = [];

    // Price Range (convert minPrice in lacs and maxPrice in crores to a common unit, e.g., rupees)
    if (this.minPrice > 0 || this.maxPrice < 100) {
      const minPriceInRupees = this.minPrice * 100000; // Convert lacs to rupees
      const maxPriceInRupees = this.maxPrice * 10000000; // Convert crores to rupees
      conditions.push(`A.Price BETWEEN ${minPriceInRupees} AND ${maxPriceInRupees}`);
    }

    // Build-Up Area
    if (this.minArea > 0 || this.maxArea < 10000) {
      conditions.push(`D.SuperArea BETWEEN ${this.minArea} AND ${this.maxArea}`);
    }

    // BHK Type
    if (this.selectedBHK) {
      const bhkValue = parseInt(this.selectedBHK.replace('BHK', ''));
      conditions.push(`D.BHK = ${bhkValue}`);
    }

    // Possession Status
    if (this.selectedPossession) {
      const possessionMapping: { [key: string]: string } = {
        'Ready to Move': "A.AvailableFrom <= GETDATE()",
        'Under Construction': "A.AvailableFrom > GETDATE()",
        'Upcoming': "A.AvailableFrom > DATEADD(MONTH, 6, GETDATE())"
      };
      conditions.push(possessionMapping[this.selectedPossession]);
    }

    // Posted Since
    if (this.selectedPostedSince && this.selectedPostedSince !== 'All') {
      const postedSinceMapping: { [key: string]: string } = {
        'Yesterday': "B.ListedOn >= DATEADD(DAY, -1, GETDATE())",
        'Last Week': "B.ListedOn >= DATEADD(WEEK, -1, GETDATE())",
        'Last 3 Week': "B.ListedOn >= DATEADD(WEEK, -3, GETDATE())",
        'Last Month': "B.ListedOn >= DATEADD(MONTH, -1, GETDATE())",
        'Last 2 Month': "B.ListedOn >= DATEADD(MONTH, -2, GETDATE())"
      };
      conditions.push(postedSinceMapping[this.selectedPostedSince]);
    }

    // Property Age
    if (this.selectedPropertyAge) {
      const [minAge, maxAge] = this.selectedPropertyAge.split(' - ').map(age => parseInt(age) || (age === '17 +' ? 17 : 0));
      if (maxAge === 17) {
        conditions.push(`D.AgeOfConstruction >= ${minAge}`);
      } else {
        conditions.push(`D.AgeOfConstruction BETWEEN ${minAge} AND ${maxAge}`);
      }
    }

    // Bathroom (Assuming you add a bathroom field in PropertyDetails table)
    if (this.selectedBathroom) {
      if (this.selectedBathroom === '5+') {
        conditions.push(`D.Bathroom >= 5`);
      } else {
        conditions.push(`D.Bathroom = ${this.selectedBathroom}`);
      }
    }

    // Floors
    if (this.selectedFloor) {
      if (this.selectedFloor === 'Ground') {
        conditions.push(`D.FloorNumber = 0`);
      } else if (this.selectedFloor === '10+') {
        conditions.push(`D.FloorNumber >= 10`);
      } else {
        const [minFloor, maxFloor] = this.selectedFloor.split(' - ').map(f => parseInt(f));
        conditions.push(`D.FloorNumber BETWEEN ${minFloor} AND ${maxFloor}`);
      }
    }

    // Furnishing
    if (this.selectedFurnishing) {
      conditions.push(`D.Furnishing = '${this.selectedFurnishing}'`);
    }

    // Combine conditions
    this.ReadAllDTO.whereClause = conditions.length > 0 ? conditions.join(' AND ') : '';

    // Apply sorting based on sort-select dropdown
    const sortSelect = (document.getElementById('sort-select') as HTMLSelectElement)?.value;
    this.ReadAllDTO.orderByClause = sortSelect ? this.getOrderByClause(sortSelect) : '';


    // Fetch filtered data
    this.fetchAllListings();
  }

  // Map sort-select value to orderByClause
  getOrderByClause(sortValue: string): string {
    switch (sortValue) {
      case 'latest':
        return 'B.ListedOn DESC';
      case 'priceLow':
        return 'A.Price ASC';
      case 'priceHigh':
        return 'A.Price DESC';
      default:
        return '';
    }
  }


}
